import { render, staticRenderFns } from "./ReviewDomainDetail.vue?vue&type=template&id=7ef2b078&scoped=true"
import script from "./ReviewDomainDetail.vue?vue&type=script&lang=js"
export * from "./ReviewDomainDetail.vue?vue&type=script&lang=js"
import style0 from "./ReviewDomainDetail.vue?vue&type=style&index=0&id=7ef2b078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef2b078",
  null
  
)

export default component.exports